var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section"},[_c('b-row',[_c('b-col',[_c('b-card',{attrs:{"title":"Log"}},[_c('div',{staticClass:"mt-4"},[_c('vue-good-table',{attrs:{"columns":_vm.columns,"rows":_vm.rows,"sort-options":{
                            enabled: true,
                            initialSortBy: { field: 'timestamp', type: 'desc' }
                        },"mode":"remote","totalRows":_vm.totalRecords,"pagination-options":{
                            enabled: true,
                            position: 'bottom',
                            perPageDropdown: [20, 50, 100],
                            dropdownAllowAll: true,
                            setCurrentPage: 1,
                            nextLabel: 'Successiva',
                            prevLabel: 'Precedente',
                            rowsPerPageLabel: 'Log per pagina',
                            ofLabel: 'of',
                            pageLabel: 'page', // for 'pages' mode
                            allLabel: 'tutti',
                        }},on:{"on-page-change":_vm.onPageChange,"on-per-page-change":_vm.onPerPageChange,"on-sort-change":_vm.onSortChange}})],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32c2b17f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/Logs/Logs.vue
// module id = null
// module chunks = 